"use client";
import React, { useState } from "react";
import Skeleton from "../Skeleton";

export default function TabLine({ items, state, setState, loading }) {
  return (
    <div className=" mt-[42px] container bg-surface1 dark:bg-dark-surface1 px-6 py-1 flex rounded-lg mb-2 h-14">
      {!loading ? (
        items.map((item) => (
          <div
            onClick={() => {
              setState(item);
            }}
            key={item}
            className={` cursor-pointer relative py-[14px] mx-[14px] text-sm font-medium tracking-[0.1] transition-colors ${
              state === item
                ? " text-primary"
                : " dark:text-dark-disable text-br-low"
            }`}
          >
            {item}
            <div
              className={`absolute -bottom-[4px] left-0 right-0 w-full h-[3px] bg-primary rounded-t-xl transition-opacity ${
                state === item ? "" : "opacity-0"
              }`}
            ></div>
          </div>
        ))
      ) : (
        <>
          <Skeleton className={'my-[14px] mx-[14px]'} width={96} height={24}/>
          <Skeleton className={'my-[14px] mx-[14px]'} width={96} height={24}/>
          <Skeleton className={'my-[14px] mx-[14px]'} width={96} height={24}/>
        </>
      )}
    </div>
  );
}
